export default class SubscribableService {
  constructor() {
    this.subscribers = [];
  }

  subscribe(callback) {
    if (typeof callback !== 'function') {
      throw new TypeError('callback is not a function');
    }
    this.subscribers.push(callback);
    return () => this.unsubscribe(callback);
  }

  unsubscribe(fn) {
    if (this.subscribers.indexOf(fn) !== -1) {
      this.subscribers.splice(this.subscribers.indexOf(fn), 1);
    }
  }

  onChange(newValues) {
    this.subscribers.filter((sub) => typeof sub === 'function').forEach((sub) => sub(newValues));
  }
}
